import { useSearchParams } from '@remix-run/react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { PLAN_LEVEL_MAP, type PlanLevel } from '~/lib/.client/plans';

export const usePaymentIntentStatusMessage = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const paymentIntentStatus = searchParams.get('payment_intent_status');
  const level = searchParams.get('level') as PlanLevel | null;

  useEffect(() => {
    if (!paymentIntentStatus) {
      return;
    }

    const newParams = new URLSearchParams(searchParams);
    newParams.delete('payment_intent_status');
    newParams.delete('level');
    newParams.delete('interval');
    setSearchParams(newParams);

    let planName = '';

    if (level && PLAN_LEVEL_MAP[level]) {
      const planInfo = PLAN_LEVEL_MAP[level];
      planName = planInfo.namePrice ? `${planInfo.name} ${planInfo.namePrice}` : planInfo.name;
    }

    if (paymentIntentStatus === 'succeeded') {
      const message = planName
        ? `Payment processed successfully! You're now on ${planName}.`
        : 'Payment processed successfully!';
      toast.success(message);
    } else {
      toast.error('Payment authentication failed. You are staying on your current plan.');
    }
  }, [paymentIntentStatus, level, searchParams, setSearchParams]);
};
